var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-snackbar',{attrs:{"bottom":"","value":_vm.syncAlert.active,"color":_vm.syncAlert.color,"timeout":-1}},[_vm._v(" "+_vm._s(_vm.syncAlert.message)+" "),_c('v-btn',{attrs:{"text":""},on:{"click":_vm.closeSnackbar}},[_vm._v(" x ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }